// @ts-nocheck
const IS_DEV = process.env.NODE_ENV === 'development'
const SERVER_SIDE = typeof window === 'undefined'
const DISABLED = IS_DEV || SERVER_SIDE

export const setup = () => {
  if (DISABLED) return

  // Initialize the UserJot queue and proxy
  window.$ujq = window.$ujq || []
  window.uj =
    window.uj ||
    new Proxy(
      {},
      {
        get: (_, p) => (...a) => window.$ujq.push([p, ...a])
      }
    )

  // Load the SDK script
  const script = document.createElement('script')
  script.src = 'https://cdn.userjot.com/sdk/v2/uj.js'
  script.type = 'module'
  script.async = true
  document.head.appendChild(script)

  // Initialize UserJot with project settings
  // trigger: 'custom' hides the default floating button - we open it via showWidget()
  window.uj.init(CONFIG.userjot.id, {
    widget: true,
    trigger: 'custom',
    position: 'right',
    theme: 'light'
  })
}

export const identify = user => {
  if (DISABLED || !window?.uj || !user) return

  const params = {
    id: user.id || user.slug,
    email: user.email,
    firstName: user.name?.split(' ')[0] || '',
    lastName:
      user.name
        ?.split(' ')
        .slice(1)
        .join(' ') || '',
    avatar: user.avatar
  }

  if (user.userjotSignature) {
    params.signature = user.userjotSignature
  }

  window.uj.identify(params)
}

export const openWidget = () => {
  if (DISABLED) return

  // If SDK hasn't loaded yet, queue the command
  if (!window?.uj || typeof window.uj.showWidget !== 'function') {
    window.$ujq = window.$ujq || []
    window.$ujq.push(['showWidget', { section: 'feedback' }])
    return
  }

  window.uj.showWidget({ section: 'feedback' })
}
